export const POINT_TEMP = '';
export const POINT_ROUTES = 'routes';
export const POINT_ROUTE = 'routePoint';
